export default "data:application/octet-stream;base64,Ci8vIEJvZHkKJGNsLW9yYW5nZTogI0ZGQUYyMDsKCgoK"